import React, { useState, useRef, useContext, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import * as auth from '../redux/AuthRedux'
import { login2Fa } from '../redux/AuthCRUD'
import { AuthContext } from '../context/AuthContext'
import { useHistory, useLocation } from 'react-router-dom'
import { KEY } from '../../../shared/constants/shared-contants'
import { TwoFactorMethod } from '../../../../app/modules/common/enum/two-factor-method'
import TwoFactorInput from "./TwoFactorInput";

interface IProps {
  cancelHandler: () => void
}

const Login2Fa: React.FC<IProps> = ({ cancelHandler }) => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const [codeDigits, setCodeDigits] = useState(Array(6).fill(''));
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);
  const [status, setStatus] = useState('');
  const history = useHistory();
  const location = useLocation<any>();
  const { email, twoFactorMethod } = useContext(AuthContext);

  useEffect(() => {
    if (!email) {
      history.push('/auth/login', location.state);
    }
  }, [history, email, location.state])

  const handleSubmit = useCallback(async (code: string) => {
    setLoading(true);
    setTimeout(() => {
      login2Fa(email, code)
        .then(({ data: { token, twoFactorEnabled } }) => {
          setLoading(false);
          dispatch(auth.actions.login(token));
        })
        .catch((err) => {
          setLoading(false);
          const code = err?.response?.data?.code ?? err?.response?.data?.Code
          const message =
            err?.response?.data?.message ??
            err?.response?.data?.Message ??
            'Something went wrong. Please try again.'

          if (code === 'PASSWORD_EXPIRED') {
            const challengeToken =
              err?.response?.data?.challengeToken ?? err?.response?.data?.ChallengeToken ?? ''
            history.push('/auth/password-expired', {
              email,
              challengeToken,
            })
            return
          }

          setStatus(message);
        });
    }, 1000);
  }, [dispatch, email, history]);

  return (
    <>
      {status ? (
        <div className='mb-lg-15 alert alert-warning'>
          <div className='alert-text font-weight-bold'>{status}</div>
        </div>
      ) : (
        <></>
      )}
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>Security Verification</h1>
        <h6 className='mb-3'>
          {twoFactorMethod === TwoFactorMethod.AuthenticatorApp ? 'Authenticator' : 'Email'}
        </h6>
        <span>
          {twoFactorMethod === TwoFactorMethod.AuthenticatorApp
            ? 'Please enter the generated code from your Authenticator Application'
            : 'Please enter the OTP sent to your email'}
        </span>
      </div>
      <TwoFactorInput onComplete={handleSubmit} />
    </>
  )
}

export { Login2Fa }
